import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';

import { PaymentHistoryTable } from '@thinknet-gmbh/platform-common-ui';

import { useGetCurrentMemberAccount } from 'src/hooks/accounts/get-current-member-account.hook';
import { useGetCurrentPaymentHistory } from 'src/hooks/subscriptions/get-current-payment-history.hook';

const PaymentsListTable = () => {
  const { t } = useTranslation();
  const [queryOptions, setQueryOptions] = useState<{
    endingBefore?: string;
    startingAfter?: string;
  }>({});
  const { member, refetch } = useGetCurrentMemberAccount();
  const paymentHistory = useGetCurrentPaymentHistory(queryOptions);

  useEffect(() => {
    if (!member.subscriptions.every((item: any) => !!item.stripeSubscriptionId)) {
      refetch();
    }
  }, [member, refetch]);

  return (
    <PaymentHistoryTable
      {...paymentHistory}
      subscriptions={member.subscriptions}
      t={t}
      queryOptions={queryOptions}
      setQueryOptions={setQueryOptions}
    />
  );
};

export default PaymentsListTable;
